// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UKIuy","rotate":"styles_rotate__FaFmr"};